import "./SupportUs.module.css";
import Header from "@/reusable_sections/Header";
import InvestmentOverview from "./sections/InvestmentOverview";
import LicenseTrackingServices from "./sections/LicenseTrackingServices";
import GetInTouch from "./sections/GetInTouch";
import Footer from "@/reusable_sections/Footer";
export default function SupportUsPage() {
  return <div>
      <Header />
      <InvestmentOverview />
      <LicenseTrackingServices />
      <GetInTouch />
      <Footer />
    </div>;
}